import { UserPlan } from './user-plan.model';
import { AvailabilityType, IAvailabilityWindowSchema } from './availability.model';

export interface IWizardConfig {
    skill: IWizardSkillName;
    isPlugin: boolean;
    taskId?: string;
    selectedMeetingType?: string; // initially selected meeting type e.g. from URL params
    componentsToHide?: Array<string>;
    isScheduled?: boolean;
    contacts?:
        | Array<{
              name: string;
              email: string;
              isVIP: boolean;
          }>
        | {
              name: string;
              email: string;
              isVIP: boolean;
          };
}

export type IWizardSkillName =
    | 'search'
    | 'meeting-create'
    | 'meeting-change'
    | 'meeting-change-attendees'
    | 'meeting-create-class'
    | 'meeting-change-class'
    | 'meeting-change-attendees-class'
    | 'meeting-create-plugin';

export interface IWizardSchema {
    json: IWizardSkill;
    id: 'meeting-create' | 'meeting-change';
    meta?: IWizardMetaData;
}

export interface IWizardSkill {
    name: string;
    id?: string;
    appName: string;
    tag: string; // the group this task belongs to
    order?: number; // abstract this out into another data object
    icon: string;
    steps?: IWizardStep[];
    pages: {
        [key: string]: IWizardPage;
    };
}

export interface IWizardStep {
    id: number;
    title: string;
    desc: string;
    icon: string;
}

export interface IWizardStepMetaData {
    appName: string;
    selection: any[];
}

export interface IWizardPage {
    id: number;
    step: number;
    content?: any;
    containerClasses?: string[];
    end?: boolean;
    form: any; // IFormOption[];
    actions: {
        style: string;
        type: string;
        nextPage?: string;
        api?: {
            endPoint: string;
            payloadKeys: string[];
        };
        label: string;
    }[];
}

export interface IWizardAction {
    label: string;
    icon?: string;
    nextPage?: WizardNextPage;
    api?: {
        endPoint: string;
        payloadKeys: string[];
    };
    style?: string;
    type?: string;
    canOverwrite?: boolean;
    mixpanel?: WizardActionTrackingEvent;
}

// TODO: we need to consolidate all the possible next-page names from server
export type WizardNextPage = 'tasks' | 'meeting' | string | undefined;
export type WizardActionTrackingEvent = {
    app: string;
    action: string;
    data?: { [key: string]: any };
};
export const TaskQueryType = ['active', 'upcoming', 'closed'] as const;

export interface IWizardMetaData {
    calendar?: {
        hasCalendarProviders: boolean;
        defaultProviderBlocked: boolean;
        hasRoomProviders?: boolean;
    };
    isAllowedApp?: boolean;
}

export interface IWizardUser {
    name: string;
    avatar: string;
    plan: UserPlan;
    timezone: string;
    isBetaUser?: boolean;
}

/** These are the fields that come back directly from the server, untransformed */
export interface IDefaultWizardOptions {
    subject: string;
    locations: { name: any }[];
    maxAttendees?: number;
    meetingLength: number;
    availabilityType: AvailabilityType;
    videoProvider?: { id: string; type: string };
    dateStart?: string;
    dateEnd?: string;
    contacts?: any[];
    meetingTime?: { start: string; end: string };
    type?: string; // TODO: Will be removed upon moving availabilityUsers logic in confirmation.ts to BE
    availabilityWindows?: IAvailabilityWindowSchema;
    roomCapacity?: number;
    calendarProviderType?: string;
}
